const PAGERDUTY_INTEGRATION_KEY = "pagerduty.com/integration-key";
const PAGERDUTY_SERVICE_ID = "pagerduty.com/service-id";

export { PAGERDUTY_INTEGRATION_KEY, PAGERDUTY_SERVICE_ID };
//# sourceMappingURL=constants.esm.js.map
